import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import SignUp from "../pages/signup";
import AboutUs from "../pages/AboutUs";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";
import ContactUs from "../pages/ContactUs";
import NotFound from "../pages/NotFound";
import SignUpTerms from "../pages/signUpTerms";
import SignupMessage from "../pages/message";
import SignIn from "../pages/signin";
import SignInOtp from "../pages/loginOtp";
import Category from "../pages/category";
import GeneratePassword from "../pages/pwdGenerate";
import Team from "../pages/team";
import Profile from "../pages/profile";
import Preference from "../pages/preference";
import CategoryContent from "../pages/categoryContent";
import Cart from "../pages/cart";
import MoreInfo from "../pages/moreInfo";
import Player from "../pages/player"; 
import Enquire from "../pages/AllEnquires/enquire";
import ViewEnquire from "../pages/AllEnquires/viewenquire";
import DynamicCategoryContent from "../pages/dynamicCategoryContent";
import MoreInfov1 from "../pages/moreinfov1";
import Partners from "../pages/partners";
import AuctionTitle from "../pages/bidding/auctiontitle";
import AuctionMoreInfo from "../pages/bidding/auctionmoreinfo";
import Bid from "../pages/bidding/bids";
import BidTerms from "../pages/bidding/bidterms";
import BidSuccess from "../pages/bidding/bidssuccess";
import ViewBid from "../pages/bidding/viewBidHistroy";
import News from "../pages/news";
import HomePage from "../pages/LandingPages/HomePage";
import ProductionHub from "../pages/LandingPages/ProductionHub";
import Blog from "../pages/LandingPages/Blog";
import MarketPlace from "../pages/LandingPages/MarketPlace";
import Dubbing from "../pages/LandingPages/Dubbing";
import Licensing from "../pages/LandingPages/Licensing";
import About from "../pages/LandingPages/About";
import Contact from "../pages/LandingPages/Contact";
// import NewHomePage from "../pages/LandingPages/NewHomePage";
import Faq from "../pages/LandingPages/Faq";
import EventsHomePage from "../pages/LandingPages/EventsHomePage";
import ThankYou from "../pages/LandingPages/ThankYou";

const AppRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<Home />} /> */}
       {/* <Route path="/" element={<HomePage />} /> */}
       <Route path="/" element={<EventsHomePage />} />
       <Route path="/thank-you" element={<ThankYou />} />
     {/* <Route path="/productioncircle" element={<ProductionHub />} />
     <Route path="/blog" element={<Blog />} />
     <Route path="/marketplace" element={<MarketPlace />} />
     <Route path="/aidubbing" element={<Dubbing />} />
<Route path="/ailicensing" element={<Licensing />} />

 <Route path="/aboutus" element={<About />} />
  <Route path="/faq" element={<Faq />} />
 
  <Route path="/contactus" element={<Contact />} />



      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<SignIn />} />
      <Route path="/loginotp" element={<SignInOtp />} />
      <Route path="/generatepassword" element={<GeneratePassword />} />

    
      <Route path="/terms/:id" element={<SignUpTerms />} />
      <Route path="/message" element={<SignupMessage />} />

      <Route path="/partners" element={<Partners />} />
      <Route path="/team" element={<Team />} />
     
      <Route path="/termsandconditions" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
     

      <Route path="/enquire" element={<Enquire />} />
      <Route path="/viewenquire/:id" element={<ViewEnquire />} />

      <Route path="/moreinfo/:id" element={<MoreInfo />} />
      <Route path="/moreinfov1/:id" element={<MoreInfov1 />} />

      <Route path="/category" element={<Category />} />
      <Route path="/content" element={<CategoryContent />} />
      <Route path="/contentv1" element={<DynamicCategoryContent />} />
      <Route path="/content/:id" element={<CategoryContent />} />

      <Route path="/news" element={<News />} />
      <Route path="/preference" element={<Preference />} />

      <Route path="/auction" element={<AuctionTitle />} />
      <Route path="/auctionmoreinfo/:id" element={<AuctionMoreInfo />} />

      <Route path="/player" element={<Player />} />
      <Route path="/bids/:id" element={<Bid />} />
      <Route path="/bidterms" element={<BidTerms />} />
      <Route path="/bidsuccess" element={<BidSuccess />} />
      <Route path="/viewbid/:id/:isgroup" element={<ViewBid />} />

      <Route path="/cart" element={<Cart />} />
      <Route path="/profile" element={<Profile />} />

   
      <Route path="*" element={<NotFound />} />
      <Route path="/orasilanding" element={<NewHomePage />} /> */}
    </Routes>
  );
};

export default AppRoutes;
